import WaitingScreen from 'components/WaitingScreen/WaitingScreen';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

const AccessRejected = () => {
  const { t } = useTranslation('waiting-screens');

  return (
    <WaitingScreen show>
      <Typography>{t('access_rejected.text')}</Typography>
    </WaitingScreen>
  );
};

export default AccessRejected;
